import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { CompanyService } from '../../../services/CompanyService';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadList, YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { initialSabitGelirListIstegi, SABIT_GELIR_TURLERI, SabitGelirKarti, SabitGelirListIstegi, SabitGelirListSonucu, SabitGelirService } from '../../../services/SabitGelirService';
import SabitGelirListFilters from './Components/SabitGelirListFilters';

/**
 * Sabit Gelir Dağıtımı listesi (standart liste ekranı, 09.10.2026; PO Eşleştirme listesiyle aynı kalıp).
 * Kartlar: aylık sabit bedel (kira sözleşmesi ya da kiralık personel) ve PO Eşleştirme satırlarına oranla dağıtımı.
 */
const SabitGelirList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const pageName = "Kargo Modülü > Nakliye > Sabit Gelir Dağıtımı"
    const pageVersion = "1";
    const [data, setData] = useState<SabitGelirListSonucu>({ list: [], totalRecordCount: 0 });
    const [filter, setFilter] = useState<SabitGelirListIstegi>(initialSabitGelirListIstegi)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Gelir Türü', name: 'turAdi', order: 0, isVisible: true },
            { title: 'Kart Adı / Not', name: 'ad', order: 0, isVisible: true },
            { title: 'Personel', name: 'personnelName', order: 0, isVisible: true },
            { title: 'Anlaşma Şablonu', name: 'agreementName', order: 0, isVisible: true },
            { title: 'Aylık Bedel', name: 'bedel', order: 0, isVisible: true },
            { title: 'Müşteriler', name: 'musteriler', order: 0, isVisible: true },
            { title: 'Satır', name: 'dagitimSayisi', order: 0, isVisible: true },
            { title: 'Toplam Oran %', name: 'toplamOran', order: 0, isVisible: true },
            { title: 'Başlangıç Tarihi', name: 'startDateStr', order: 0, isVisible: true },
            { title: 'Bitiş Tarihi', name: 'endDateStr', order: 0, isVisible: true },
            { title: 'Aktif', name: 'isCustomActive', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteSabitGelir = async () => {
        try {
            var selectedIds = data.list.filter(x => x.isSelected).map(x => x.sabitGelirKartiId);

            dispatch(storeActivityIndicator(true))

            var response = await SabitGelirService.sil(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success('Seçilen kartlar silindi.')

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateSabitGelir = async (_id: string | undefined = undefined) => {
        navigate('/sabitgelir/listadd?id=' + (_id ? _id : data.list.filter(x => x.isSelected)[0].sabitGelirKartiId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: SabitGelirListIstegi | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response = await SabitGelirService.getListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            list: data.list.map(function (x) {
                if (x.sabitGelirKartiId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.list.length == data.list.filter(x => x.isSelected).length;

        setData({
            ...data,
            list: data.list.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await SabitGelirService.exportList(buildExcelRequest(filter, mode, data.list.filter(x => x.isSelected).map(x => x.sabitGelirKartiId), columns));

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Oluşturan/güncelleyen bilgisi
    // iki parça halinde gösterildiği için listede yok.
    const sortableColumns = [
        'turAdi', 'ad', 'personnelName', 'agreementName', 'bedel', 'musteriler',
        'dagitimSayisi', 'toplamOran', 'startDateStr', 'endDateStr', 'isCustomActive'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (SabitGelirListe) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        turAdi: { type: 'select', allowEmpty: false, loadOptions: () => Promise.resolve(SABIT_GELIR_TURLERI.map(x => ({ value: String(x.value), label: x.label }))) },
        ad: { type: 'text' },
        personnelName: { type: 'text' },
        agreementName: { type: 'text' },
        bedel: { type: 'number' },
        musteriler: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isCustomer: true }), 'companyId', x => x.name) },
        dagitimSayisi: { type: 'number' },
        toplamOran: { type: 'number' },
        startDateStr: { type: 'date' },
        endDateStr: { type: 'date' },
        isCustomActive: YES_NO_FILTER,
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: SabitGelirKarti, column: string, index: number, className: string | undefined) => {
        if (column == "isCustomActive") {
            return (
                <td className={className} onClick={() => setItemSelected(item.sabitGelirKartiId)} onDoubleClick={() => updateSabitGelir(item.sabitGelirKartiId)}><StatusBadge text={item.isCustomActive ? "Evet" : "Hayır"} /></td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.sabitGelirKartiId)} onDoubleClick={() => updateSabitGelir(item.sabitGelirKartiId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.sabitGelirKartiId)} onDoubleClick={() => updateSabitGelir(item.sabitGelirKartiId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else if (['bedel', 'toplamOran'].includes(column)) {
            var item2: any = item;
            // Toplam oran %100 değilse kart siparişte kullanılamaz; kırmızı gösterilir.
            var eksik = column == 'toplamOran' && Math.abs((item.toplamOran ?? 0) - 100) > 0.0001;
            return <td className={(className ?? '') + (eksik ? ' text-danger' : '')} onClick={() => setItemSelected(item.sabitGelirKartiId)} onDoubleClick={() => updateSabitGelir(item.sabitGelirKartiId)}>{item2[column] != null ? Helpers.correctPrice(item2[column], 2) : ''}</td>;
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={() => setItemSelected(item.sabitGelirKartiId)} onDoubleClick={() => updateSabitGelir(item.sabitGelirKartiId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <SabitGelirListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.list.filter(x => x.isSelected).length}
                    deleteFunction={deleteSabitGelir}
                    updateFunction={updateSabitGelir}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.list.filter(x => x.isSelected).length > 0 && data.list.filter(x => x.isSelected).length == data.list.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.list.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.list.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.sabitGelirKartiId)} className='form-check-input' type='checkbox' checked={item.isSelected ?? false} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.list.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default SabitGelirList;
